import { lazy } from 'react';

import { renderRoutesFromArray } from './renderRoutesFromArray';

const Duels = lazy(() => import('../screens/main/duels'));
const Duel = lazy(() => import('../screens/main/duel'));
const DuelOverview = lazy(() => import('../screens/main/duel/overview'));
const CreateRound = lazy(() => import('../screens/main/duel/create-round'));
const Question = lazy(() => import('../screens/main/duel/question'));

const routeDefinitions = [
  {
    path: '/duels',
    element: <Duels />,
  },
  {
    path: '/duel/:duelId/create-round',
    element: (
      <Duel>
        <CreateRound />
      </Duel>
    ),
  },
  {
    path: '/duel/:duelId/create-round/session/:sessionId/member/:memberId',
    element: (
      <Duel>
        <CreateRound />
      </Duel>
    ),
  },
  {
    path: '/duel/:duelId/create-round/session/:sessionId',
    element: (
      <Duel>
        <CreateRound />
      </Duel>
    ),
  },
  {
    path: '/duel/:duelId/round/:roundId/question/:questionId',
    element: <Question />,
  },
  {
    path: '/duel/:duelId/overview',
    element: (
      <Duel>
        <DuelOverview />
      </Duel>
    ),
  },
];

const duelRoutes = renderRoutesFromArray(routeDefinitions);
export default duelRoutes;
